<template>
  <v-card :elevation="$root.ele">
    <v-card-text class="pb-0 pt-2">
      <v-row>
        <v-col cols="12" sm="3">
          <DateRange
            :clearable="true"
            v-model="form.updated_at"
            label="Date Range (Created On)"
          />
        </v-col>
        <v-col cols="12" sm="3">
          <v-select
            item-text="name"
            item-value="value"
            dense
            outlined
            hide-details
            v-model="form.status"
            :items="status"
            label="Job Status"
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-select
            item-text="name"
            item-value="value"
            dense
            outlined
            hide-details
            v-model="form.disposition"
            :items="dispositions"
            label="Disposition"
          >
          </v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-autocomplete
            outlined
            item-text="name"
            item-value="id"
            :items="templates"
            v-model="form.template"
            dense
            hide-details
            label="Job Type"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3">
          <v-autocomplete
            item-text="name"
            outlined
            item-value="value"
            :items="technicians"
            v-model="form.technician"
            dense
            hide-details
            label="Technicians"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="9" class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            @click="reset()"
            outlined
            tile
            depressed
            width="100"
            >Reset</v-btn
          >
          <v-btn text class="primary ml-2" tile width="100" @click="fetch()">
            Apply</v-btn
          >
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import DateRange from "../DateRange";
import smsList from "../../assets/js/sms_status";
import { status } from "../../assets/js/default.js";
import moment from "moment";
import { customers } from "../../assets/js/firebase.js";
import { formatDateTime } from "../../assets/js/common";
export default {
  props: {
    value: Object
  },
  components: {
    DateRange
  },
  data() {
    return {
      status: status,
      list: [],
      form: {
        updated_at: [],
        status: -1,
        technician: "all",
        template: "all",
        sms: "all",
        disposition: "all"
      }
    };
  },
  computed: {
    technicians() {
      let list = this.$store.getters.technicians.map(item => {
        let name = item.first_name + " " + item.last_name;
        return { name: name, value: item.id };
      });
      list.unshift({
        name: "All",
        value: "all"
      });
      return list;
    },
    dispositions() {
      let list = this.$store.getters.dispositions.map(item => {
        let name = item.name;
        return { name: name, value: item.id };
      });
      list.unshift({
        name: "All",
        value: "all"
      });
      return list;
    },
    templates() {
      let list = [];
      let templates = this.$store.getters.templates;

      templates.forEach(item => {
        if (item.type === 0) list.push(item);
      });
      list = list.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      list.unshift({
        name: "All",
        id: "all"
      });
      return list;
    },
    sms() {
      let list = [];
      list.push({
        name: "All",
        value: "all"
      });
      Object.keys(smsList).forEach(key => {
        list.push({
          name: smsList[key],
          value: key
        });
      });
      return list;
    },
    date() {
      const vm = this;
      let { updated_at } = vm.form;
      let start = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DDTHH:mm:ss");
      let end = vm.end(new Date());
      if (updated_at.length === 1) {
        start = vm.start(updated_at[0]);
        end = vm.end(updated_at[0]);
      }
      if (updated_at.length === 2) {
        let date1 = moment(updated_at[0]);
        let date2 = moment(updated_at[1]);
        if (date1.isBefore(date2)) {
          start = vm.start(date1);
          end = vm.end(date2);
        } else {
          start = vm.start(date2);
          end = vm.end(date1);
        }
      }
      return { start, end };
    }
  },
  methods: {
    start(date) {
      return moment(date)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    end(date) {
      return moment(date)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss");
    },
    reset() {
      const vm = this;
      let start = moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      let end = moment().format("YYYY-MM-DD");
      vm.form = {
        updated_at: [start, end],
        status: -1,
        template: "all",
        technician: "all",
        disposition: "all",
        sms: "all"
      };
      vm.$store.commit("SET_JOB_QUERY", {});
      vm.init();
    },
    async fetch() {
      const vm = this;
      let { status, template, sms, technician, disposition } = vm.form;
      let doc = {};
      Object.keys(vm.form).forEach(key => {
        doc[key] = vm.form[key];
      });
      vm.$store.commit("SET_JOB_QUERY", doc);
      let { start, end } = vm.date;
      let query = customers
        .orderBy("created_at", "desc")
        .where("created_at", ">=", start)
        .where("created_at", "<=", end);
      if (status !== -1) {
        query = query.where("status", "==", status);
      } else {
        query = query.where("status", "in", [1, 2, 3, 5, 6, 7]);
      }
      if (template !== "all") query = query.where("template", "==", template);
      if (sms !== "all") query = query.where("sms", "==", sms);
      if (technician !== "all")
        query = query.where("technician", "==", technician);
      if (disposition !== "all")
        query = query.where("disposition", "==", disposition);
      vm.$store.commit("SET_JOBS", []);
      try {
        let list = [];
        vm.$root.loader = true;
        let snap = await query.get();
        snap.docs.forEach(item => {
          let doc = item.data();
          doc.id = item.id;
          doc.created_at = formatDateTime(doc.created_at);
          doc.updated_at = formatDateTime(doc.updated_at);
          list.push(doc);
        });
        vm.$store.commit("SET_JOBS", list);
        vm.$root.loader = false;
      } catch (e) {
        vm.$root.loader = false;
        vm.$root.alert(e.message);
      }
    },
    init() {
      const vm = this;
      let doc = vm.$store.getters.jobQuery;
      if (doc.updated_at === undefined) {
        vm.fetch();
      }
      Object.keys(vm.form).forEach(key => {
        if (doc[key] !== undefined) {
          vm.form[key] = doc[key];
        }
      });
      vm.fetch();
    }
  },
  beforeMount() {
    this.init();
  }
};
</script>

<style></style>
